import React from 'react';
import PropTypes from 'prop-types';

import HorseDefinition from '../../../shared/HorseDefinition';

const Dam = ({
    damHorseName,
    damUid,
    damCountryOriginCode,
    isWeatherbysMobile,
}) => (
    <HorseDefinition
        countryOriginCode={damCountryOriginCode}
        horseName={damHorseName}
        horseUid={damUid}
        term={isWeatherbysMobile ? '' : 'Dam'}
    />
);

Dam.propTypes = {
    damHorseName: PropTypes.string,
    damUid: PropTypes.number,
    damCountryOriginCode: PropTypes.string,
    isWeatherbysMobile: PropTypes.bool,
};

export default Dam;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Dam.jsx